import * as types from './mutation-types';
import CacheHelper from '@/cacheHelper';

const cache = new CacheHelper({
  key: 'CACHE_KEY',
  ttl: 60 * 5, // 5 mins
});

/**
 * All VueX actions should go here.
 * They should check if data exists via the cache, and any api calls should be made to the /flat endpoint by default
 */
export const actions = {
  /**
   * Set the filter limit of results
   * TODO: Should this be global?
   */
  async setLimit({ commit }, limit) {
		commit(types.SET_FILTER_LIMIT, limit)
		return Promise.resolve(limit)
  },

  /**
   * Clear localStorage cache
   * * TODO: Should this be global?
   */
  async clearCache(context) {
    cache.removeItem(cacheConfig.key)
    return Promise.resolve(cacheConfig.key)
  },
};
